import { render } from "./AlmChangesetNameRenderer.vue?vue&type=template&id=4e89e530&ts=true"
import script from "./AlmChangesetNameRenderer.vue?vue&type=script&lang=ts"
export * from "./AlmChangesetNameRenderer.vue?vue&type=script&lang=ts"

import "./AlmChangesetNameRenderer.vue?vue&type=style&index=0&id=4e89e530&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__